// Steps/AudienceSelection.js - Step 1 Component
import React, { useContext, useEffect } from 'react';
import {
    Box,
    Typography,
    FormControl,
    FormLabel,
    RadioGroup,
    FormControlLabel,
    Radio,
    Card,
    CardContent,
    Avatar
} from '@mui/material';
import { People, Engineering } from '@mui/icons-material';
import { NotificationDataContext } from '../AddEditNotification';

const AudienceSelection = () => {
    const { notificationData, setNotificationData ,initialState} = useContext(NotificationDataContext);

    const handleAudienceChange = (event) => {
        const audienceType = event.target.value;
        setNotificationData(prev => ({
            ...prev,
            audienceType,
            // Reset filters when changing audience type
            
        }));
    };
    useEffect(() => {
        if(notificationData.audienceType){
            setNotificationData(pre=>{
                return{
                    ...pre,
                    customerFilters: initialState.customerFilters,
                    expertFilters: initialState.expertFilters
            }})
        }
    }, [notificationData.audienceType]);

    const audienceOptions = [
        {
            value: 'customer',
            title: 'Customers',
            description: 'Send notifications to your customer base',
            icon: <People sx={{ fontSize: 40, color: 'primary.main' }} />,
            details: 'Target your registered customers with personalized notifications'
        },
        {
            value: 'expert',
            title: 'Service Experts',
            description: 'Send notifications to expert professionals',
            icon: <Engineering sx={{ fontSize: 40, color: 'primary.main' }} />,
            details: 'Communicate with your service experts with personalized notifications'
        }
    ];

    return (
        <Box>
            <Box sx={{display: 'flex', alignItems: 'center',justifyContent:'space-between'}}>
                <Typography  gutterBottom sx={{ mb: 1, fontWeight: 600 ,fontSize:'0.85rem'}}>
                    Select Your Target Audience
                </Typography>
                {/* Selected Audience Info */}
                {notificationData.audienceType && (
                    <Box 
                        sx={{ 
                            // mt: 4, 
                            p: .5, 
                            bgcolor: 'success.50', 
                            borderRadius: 1, 
                            border: '1px solid', 
                            borderColor: '#32cd32' ,
                            display:"flex",
                            
                        }}
                    >
                        <Typography sx={{ fontWeight: 600, color: '#008000',mr:1,fontSize:'0.75rem' }}>
                            ✓ Selected: {notificationData.audienceType === 'customer' ? 'Customers' : 'Experts'}
                        </Typography>
                        <Typography sx={{ color: '#32cd32',fontSize:'0.65rem' }}>
                            You can proceed to apply specific filters for your selected audience in the next step.
                        </Typography>
                    </Box>
                )}
            </Box>
            <FormControl component="fieldset" fullWidth>
                {/* <FormLabel 
                    component="legend" 
                    sx={{ 
                        fontSize: '0.9rem', 
                        fontWeight: 600, 
                        mb: 2,
                        '&.Mui-focused': {
                            color: 'text.primary'
                        }
                    }}
                >
                    Choose audience type:
                </FormLabel> */}
                
                <RadioGroup
                    value={notificationData.audienceType}
                    onChange={handleAudienceChange}
                    sx={{ mt: 2 }}
                >
                    <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
                        {audienceOptions.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={<Radio sx={{ display: 'none' }} />}
                                label={
                                    <Card
                                        sx={{
                                            // minWidth: 280,
                                            cursor: 'pointer',
                                            border: 2,
                                            borderColor: notificationData.audienceType === option.value 
                                                ? 'primary.main' 
                                                : 'grey.300',
                                            bgcolor: notificationData.audienceType === option.value 
                                                ? 'primary.50' 
                                                : 'background.paper',
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                borderColor: 'primary.main',
                                                transform: 'translateY(-2px)',
                                                boxShadow: 2
                                            }
                                        }}
                                    >
                                        <CardContent sx={{ textAlign: 'center', p: 1 }}>
                                            <Avatar
                                                sx={{
                                                    width: 60,
                                                    height: 60,
                                                    bgcolor: notificationData.audienceType === option.value 
                                                        ? 'primary.main' 
                                                        : 'grey.100',
                                                    mx: 'auto',
                                                    // mb: 2
                                                }}
                                            >
                                                {React.cloneElement(option.icon, {
                                                    sx: { 
                                                        fontSize: 30, 
                                                        color: notificationData.audienceType === option.value 
                                                            ? 'white' 
                                                            : 'primary.main'
                                                    }
                                                })}
                                            </Avatar>
                                            
                                            <Typography 
                                                variant="h6" 
                                                gutterBottom
                                                sx={{
                                                    fontWeight: 600,
                                                    fontSize: '.85rem',
                                                    color: notificationData.audienceType === option.value 
                                                        ? 'primary.main' 
                                                        : 'text.primary'
                                                }}
                                            >
                                                {option.title}
                                            </Typography>
                                            
                                            <Typography 
                                                color="text.secondary"
                                                sx={{fontSize: '0.75rem'}}
                                            >
                                                {option.description}
                                            </Typography>
                                            
                                            <Typography 
                                                variant="caption" 
                                                sx={{ 
                                                    fontSize: '0.65rem',
                                                    fontStyle: 'italic',
                                                    color: 'text.secondary'
                                                }}
                                            >
                                                {option.details}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                }
                                sx={{ m: 0 }}
                            />
                        ))}
                        
                    </Box>
                </RadioGroup>
            </FormControl>

            
        </Box>
    );
};

export default AudienceSelection;